<div class="esc-dialog-container" [attr.data-testid]="ELEMENT_IDS['dlg']">
    <div class="esc-dialog-header">
        <div class="esc-dialog-header-title">
            <h6 i18n [attr.data-testid]="ELEMENT_IDS['lbl_title']">Select Warehouse</h6>
        </div>
        <div class="esc-dialog-header-action">
            <button mat-icon-button (click)="onClose()" [attr.data-testid]="ELEMENT_IDS['btn_close']">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <div class="esc-dialog-content" style="padding-top: 2px !important;">
        <form [formGroup]="inputForm">
            <app-custom-select
              [elementId]="ELEMENT_IDS['dropdown_warehouse']"
              label="Warehouse"
              controlName="warehouse"
              [dataSource]="warehouseData"
              valueRef="description"
              [defaultValue]="getDefaultValue()"
              >
              <ng-template #optionTemplate let-option>
                <span>{{option.description}}</span>
              </ng-template>
            </app-custom-select>
        </form>
    </div>

    <div class="esc-dialog-content-action">   
      <app-custom-button
          [elementId]="ELEMENT_IDS['btn_cancel']"
          buttonType="secondary"
          text="Cancel"
          (onClick)="onClose()"
          [density]="1"
        ></app-custom-button> 
        <app-custom-button
          [elementId]="ELEMENT_IDS['btn_confirm']"
          buttonType="primary"
          text="Confirm"
          (onClick)="onSubmit()"
          [density]="1"
          [disabled]="disableConfirm()"
        ></app-custom-button>
    </div>
</div>
